import axios, { AxiosResponse } from 'axios';
import {
    ApiCallStatistic,
    ApiCallStatisticsFilters,
    ApiCallStatisticsParams,
    ApiServiceDictionaryItem,
    PageResponse,
} from './types';

const requestConfig = {
    skipGlobalError: true,
};

export const getApiServiceDictionary = (): Promise<
    AxiosResponse<ApiServiceDictionaryItem[]>
> => {
    return axios.get('/services/isnaportal/api/admin/api-service-dictionary', {
        ...requestConfig,
        params: {
            onlyActive: true,
        },
    } as any);
};

export const getApiCallStatistics = (
    params: ApiCallStatisticsParams,
    signal?: AbortSignal
): Promise<AxiosResponse<PageResponse<ApiCallStatistic>>> => {
    return axios.get('/services/isnaportal/api/admin/billing/stat', {
        ...requestConfig,
        params,
        signal,
    } as any);
};

export const getApiCallStatisticsCsv = (
    params: ApiCallStatisticsFilters
): Promise<AxiosResponse<Blob>> => {
    return axios.get('/services/isnaportal/api/admin/billing/stat/csv', {
        ...requestConfig,
        params,
        responseType: 'blob',
    } as any);
};